import styles from './NavItem.module.css'
import Link from '../../../../Routing/Link'
import React from 'react'
import PropTypes from 'prop-types'

const NavItem = ({ link, label, isActive }) =>
  <div className={ `${styles.wrapper} ${isActive ? styles.active : ''}` }>
    <Link href={ link }>{ label }</Link>
    <hr />
  </div>

NavItem.propTypes = {
  link: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
}

export default NavItem
